/**
 * @description: 文章路由文件
 * @author: lx
 * @Compile：2022-05-24 11：00
 * @update: lx(2022-05-24 11：00)
 */
export default [
  {
    path: "/articleCategory",
    component: () => import("../../pages/lookfor/article/articleCategory/articleCategory.vue"),
    name: "articleCategory",
    title: "文章分类管理",
    meta: {
      title: "文章分类管理"
    }
  },
  {
    path: "/articleManage",
    component: () => import("../../pages/lookfor/article/articleManage/articleManage.vue"),
    name: "articleManage",
    title: "文章管理",
    meta: {
      title: "文章管理"
    }
  },
  {
    path: "/recommendVideo",
    component: () => import("../../pages/lookfor/article/recommendVideo/recommendVideo.vue"),
    name: "recommendVideo",
    title: "推荐视频",
    meta: {
      title: "推荐视频"
    }
  },
  {
    path: "/articleEvaluation",
    component: () => import("../../pages/lookfor/article/evaluation/evaluation.vue"),
    name: "articleEvaluation",
    title: "文章评论管理",
    meta: {
      title: "文章评论管理"
    }
  },
]